import React from 'react';
import { View, Text, StyleSheet, Animated } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { isIOS, machineStatusColorName, isPhone, navigateBack, navigateTo, chartStatuses, Popup, getLinkingModalConfig } from '@helpers';

import AnimatedHeader, { getHeight } from '@components/common/AnimatedHeader';
import TouchableElement from '@components/common/touchableElement';
import ColorWrapper from '@styles/colors';
import { font as initialFont } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { scale as initialScale, ratio, notchTop, fullWidth, width } from '@components/frame';

import Timeline from './components/timeline';
import LevelSelector from './components/levelSelector';
import ProductionInformation from '@components/productionInformation';
import { SelectedLevel } from '@components/productionInformation/baseWithERP/types';
import { useNavigation, useRoute } from '@react-navigation/native';
import { NowSubScreen } from '@v2/pages/machines/common/enums';
import { useHandleNavigationMachinesHeader } from '@v2/pages/machines/hooks/useHandleNavigationMachineHeader';
import { setIsMachinesSelectModalOpen } from '@reducers/machinesV2';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import { setTimePeriod } from '@reducers/params';

let secretScreen = 0;

const DetailsHeader = ({
  selectedItem = {},
  C,
  setActionsModalOpen,
  showMachineInfo,
  panelViewMode,
  clampingTools,
  scale = initialScale,
  font = initialFont,
  highlightHeader,
  noMachine,
  isNCFile,
  onBack,
  switchMachine,
  allSelected,
  onlyTime,
  hideName,
  setIsMachinesSelectModalOpen,
  batchText,
  setTimePeriod,
}) => {
  const route = useRoute();
  const { isNowSubScreen } = useHandleNavigationMachinesHeader();
  const { timePeriod } = useHandleParams();
  const navigation = useNavigation();

  const isNCFileLevel = route.name.includes(NowSubScreen.NC_FILE); // TODO: add also for ncFiles subscreens
  const isPartLevel = route.name.includes(NowSubScreen.PART); // TODO: add also for ncFiles subscreens
  const isToolsLevel = route.name.includes(NowSubScreen.TOOLS); // TODO: add also for ncFiles subscreens
  const isNow = isNowSubScreen; // TODO: add also for ncFiles subscreens

  const HeaderAction = ({ top, zIndex }) => {
    if (selectedItem?.partDetails?.partId)
      if (noMachine) {
        return selectedItem?.machineStatus?.ncFileId ? (
          <View key={'header-action'} style={{ position: 'absolute', right: scale(18), top: scale(isPhone ? (top ? 18 : 23) : 21), zIndex }}>
            <View style={{ flexDirection: 'row' }}>
              <View style={{ marginLeft: scale(36) }}>
                <TouchableElement
                  onPress={() => {
                    const partId = selectedItem?.machineStatus?.partDetails?.partId;
                    Popup({
                      Component: (p) => (
                        <ProductionInformation
                          {...{
                            ...p,
                            onBackPress: p.hide,
                            selectedNCFileId: selectedItem?.machineStatus?.ncFileId,
                            partId: selectedItem?.machineStatus?.partDetails?.partId,
                            existingSelectedLevel: partId ? SelectedLevel.Part : null,
                            partId,
                            context: 'batch',
                          }}
                        />
                      ),
                      ...getLinkingModalConfig(scale, fullWidth),
                    });
                  }}
                >
                  {({ boxStyle }) => (
                    <View style={[boxStyle]}>
                      <Text style={[font.Body, { color: C('Button/Light/Primary') }]}>{i18n.t('Edit')}</Text>
                    </View>
                  )}
                </TouchableElement>
              </View>
            </View>
          </View>
        ) : null;
      }
    return [
      !isPhone && highlightHeader && (
        <View key={'machine-name'} style={{ position: 'absolute', left: scale(10), top: scale(33), zIndex }}>
          <View
            style={{
              backgroundColor: C(machineStatusColorName[selectedItem?.machineStatus?.status]),
              paddingHorizontal: scale(10),
              paddingVertical: scale(5),
              borderRadius: scale(12),
            }}
          >
            <Text style={[font['Title 1'], { color: C('Label/Dark/Primary', false) }]}>{selectedItem?.fullName}</Text>
          </View>
        </View>
      ),
      <View key={'header-action'} style={{ position: 'absolute', right: scale(18), top: scale(isPhone ? (top ? 18 : 23) : 44), zIndex }}>
        <View style={{ flexDirection: 'row' }}>
          <TouchableElement onPress={() => setActionsModalOpen(true)}>
            {({ boxStyle }) => (
              <View style={[boxStyle]}>
                <Svg icon="more" width={scale(22)} height={scale(22)} color={'Button/Light/Primary'} />
              </View>
            )}
          </TouchableElement>
          {showMachineInfo && !isPhone && !isToolsLevel && isNow && (
            <View style={{ marginLeft: scale(36) }}>
              <TouchableElement
                onPress={() => {
                  const partId = selectedItem?.machineStatus?.partDetails?.partId;
                  Popup({
                    Component: (p) => (
                      <ProductionInformation
                        {...{
                          ...p,
                          onBackPress: p.hide,
                          close: p.hide,
                          selectedNCFileId: selectedItem?.machineStatus?.ncFileId,
                          partId: selectedItem?.machineStatus?.partDetails?.partId,
                          existingSelectedLevel: partId ? SelectedLevel.Part : null,
                          partId,
                          context: 'batch',
                        }}
                      />
                    ),
                    ...getLinkingModalConfig(scale, fullWidth),
                  });
                }}
              >
                {({ boxStyle }) => (
                  <View style={[boxStyle]}>
                    <Text style={[font.Body, { color: C('Button/Light/Primary') }]}>{i18n.t('Edit')}</Text>
                  </View>
                )}
              </TouchableElement>
            </View>
          )}
          {panelViewMode && (
            <View style={{ marginLeft: scale(36) }}>
              <TouchableElement
                onPress={() => {
                  if (onBack) {
                    onBack();
                  } else {
                    navigateBack();
                  }
                }}
              >
                {({ boxStyle }) => (
                  <View style={[boxStyle]}>
                    <Text style={[font.Body, { color: C('Button/Light/Primary') }]}>{i18n.t('Close')}</Text>
                  </View>
                )}
              </TouchableElement>
            </View>
          )}
        </View>
      </View>,
    ];
  };

  const PanelHeaderText = () => (
    <View style={{ flex: 1, paddingHorizontal: scale(12), justifyContent: 'center' }}>
      <Text
        style={[
          font['Subhead 2'],
          {
            color: C('Label / Light / Primary'),
            textAlign: 'center',
            marginTop: scale(7),
          },
        ]}
        numberOfLines={1}
      >
        {i18n.t('Production Information')}
      </Text>
      <Text
        style={[
          font['Caption 2'],
          {
            color: C('Label / Light / Primary'),
            textAlign: 'center',
            marginTop: scale(-2),
          },
        ]}
        numberOfLines={1}
        ellipsizeMode="middle"
      >
        {isPartLevel ? selectedItem?.machineStatus?.partDetails?.partName : ''}
        {isNCFileLevel ? selectedItem?.machineStatus?.ncFileName : ''}
      </Text>
    </View>
  );

  const headerHeight = getHeight();

  const goToSecret = () => {
    if (secretScreen === 4) {
      secretScreen = 0;
      navigateTo('MachineDetailsSecret', { id: selectedItem.machineId });
    } else {
      secretScreen += 1;
    }
  };

  const config = {
    velocityThreshold: 0.3,
    directionalOffsetThreshold: 80,
  };

  const isPhoneMachineList = allSelected && isPhone;

  return (
    <Animated.View
      style={{
        backgroundColor: C('Background/Light/Detail'),
        width: '100%',
      }}
    >
      {isPhoneMachineList ? (
        <View style={{ height: notchTop + scale(76) }}></View>
      ) : (
        <Animated.View
          style={[
            {
              height: isPhone || noMachine ? headerHeight : scale(panelViewMode ? 34 : 37) + notchTop,
              marginTop: scale(isPhone ? 0 : 20),
              zIndex: 10000,
            },
          ]}
        >
          {isPhone || noMachine ? (
            <>
              <Animated.View
                style={{
                  zIndex: 10001,
                }}
              >
                <AnimatedHeader
                  {...{
                    backText: i18n.t(noMachine ? 'Back' : 'Machines'),
                    onBackPress: onBack || false,
                    actions: [{ component: HeaderAction, key: 'HeaderAction' }],
                    text: '',
                    C,
                    animated: false,
                    back: true,
                    backgroundColor: 'Background/Light/Detail',
                    borderBottomWidth: 0,
                    TextComponent: panelViewMode && isPhone ? PanelHeaderText : null,
                    scale,
                    font,
                  }}
                >
                  <View
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: scale(25),
                      position: 'absolute',
                      zIndex: 1001,
                      top: scale(25),
                      right: scale(65),
                    }}
                  >
                    <TouchableElement onPress={() => switchMachine('up')}>
                      {({ boxStyle }) => (
                        <View style={[boxStyle]}>
                          <Svg
                            icon="chevronBottomLight"
                            height={25}
                            width={25}
                            color={'Button/Light/Primary'}
                            style={{ transform: [{ rotate: '180deg' }] }}
                          />
                        </View>
                      )}
                    </TouchableElement>
                    <TouchableElement onPress={() => switchMachine('down')}>
                      {({ boxStyle }) => (
                        <View style={[boxStyle]}>
                          <Svg icon="chevronBottomLight" height={25} width={25} color={'Button/Light/Primary'} />
                        </View>
                      )}
                    </TouchableElement>
                  </View>
                </AnimatedHeader>
              </Animated.View>
            </>
          ) : onlyTime ? null : (
            <HeaderAction />
          )}
        </Animated.View>
      )}
      {!highlightHeader && !noMachine && (
        <View
          style={[
            {
              flexDirection: 'row',
              justifyContent: 'space-between',
              opacity: hideName ? 0 : 1,
            },
            { paddingLeft: scale(isPhoneMachineList ? 6 : 18), paddingRight: scale(18) },
          ]}
        >
          <View style={{ paddingRight: isPhone ? scale(75) : 0 }}>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <View
                style={{
                  backgroundColor: selectedItem?.machineStatus?.status ? C(machineStatusColorName[selectedItem.machineStatus.status]) : 'transparent',
                  height: scale(12.5),
                  width: scale(12.5),
                  borderRadius: scale(12.5 / 2),
                  opacity: !isNow || noMachine || selectedItem?.isProcessingPI || selectedItem?.machineStatisticsOnly ? 0 : 1,
                }}
              />
              <TouchableElement onPress={() => goToSecret()}>
                {() => (
                  <View>
                    <Text
                      style={[
                        {
                          color: C('Label / Light / Primary'),
                          marginLeft: scale(isPhoneMachineList ? 0 : 7),
                        },
                        font[isPhoneMachineList ? 'Large Title' : 'Title 2'],
                      ]}
                      numberOfLines={1}
                      ellipsizeMode={'middle'}
                    >
                      {isPhoneMachineList ? i18n.t('Machines') : selectedItem?.shortName}
                    </Text>
                  </View>
                )}
              </TouchableElement>
              {isPhone && !isPhoneMachineList && (
                <TouchableElement onPress={() => setIsMachinesSelectModalOpen(true)}>
                  {({ boxStyle }) => (
                    <View
                      style={[
                        boxStyle,
                        {
                          marginLeft: scale(10),
                          backgroundColor: C('Button/Light/Secondary'),
                          borderRadius: scale(8),
                          width: scale(17),
                          height: scale(17),
                          justifyContent: 'center',
                          alignItems: 'center',
                        },
                      ]}
                    >
                      <Svg icon="chevronBottomLight" height={10} width={10} color={'Button/Light/Primary'} />
                    </View>
                  )}
                </TouchableElement>
              )}
            </View>
          </View>
        </View>
      )}
      {!noMachine && (
        <View
          style={[
            {
              alignContent: 'center',
              alignItems: 'center',
              justifyContent: 'center',
            },
          ]}
        >
          <View
            style={{
              width: isPhone ? '100%' : ratio < 1.5 ? '63%' : '56.5%',
              marginTop: scale(23),
            }}
          >
            <Timeline
              {...{
                setActiveTimeLine: (d) => {
                  // if (d !== 'day') {
                  //   if (route.name.includes(MachinesScreen.EVENTS)) {
                  //     setSelectedPeriod(chartStatuses.productive);
                  //   }
                  // }
                  setTimePeriod(d);
                },
                activeTimeLine: timePeriod,
                blur: isPhone,
                colors: { light: '242, 243, 247', dark: '0, 0, 0' },
                scale,
                font,
              }}
            />
          </View>
        </View>
      )}
      {showMachineInfo && isNow && (
        <View
          style={[
            {
              height: scale(panelViewMode ? 58 : isPhone ? 49 : 43),
              alignContent: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              marginTop: scale(isPhone ? 0 : 12),
            },
            isPhone && isNCFile
              ? {
                  borderBottomColor: C('Hairline/Light/Primary'),
                  borderBottomWidth: StyleSheet.hairlineWidth,
                }
              : {
                  paddingHorizontal: scale(18),
                },
            isPhone &&
              !allSelected && {
                marginTop: scale(12),
                borderTopColor: C('Hairline/Light/Primary'),
                borderTopWidth: StyleSheet.hairlineWidth,
              },
          ]}
        >
          <LevelSelector
            {...{
              panelViewMode,
              ncFile: selectedItem.machineStatus?.ncFile,
              partName: selectedItem.machineStatus?.partDetails?.partName,
              partId: selectedItem.machineStatus?.partDetails?.partId,
              clampingTools,
              scale,
              font,
              isNCFile,
              blur: isPhone,
              big: !isPhone,
              noMachine,
              selectedItem,
              batchText,
            }}
          />
        </View>
      )}
    </Animated.View>
  );
};

const mapStateToProps = ({ user, membership }) => ({ user, membership });

export default connect(mapStateToProps, { setIsMachinesSelectModalOpen, setTimePeriod })(ColorWrapper(DetailsHeader));
